/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'renewal/chart': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M7 12.307a1.5 1.5 0 013 0v9.307H7v-9.307zM2 6.412a1.5 1.5 0 113 0v15.202H2V6.412zM13 3.465a1.5 1.5 0 013 0v18.149h-3V3.464zM19 8.377a1.5 1.5 0 013 0v13.237h-3V8.377z" _fill="currentColor"/>'
  }
})
